import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const ProblemsTab = ({ filteredProblems, handleEditProblem, handleEmailProblem, handleOpenProblemView, handlePrintProblemById }) => (
  <>
    <div className="space-y-4">
      {filteredProblems.map((problem) => (
        <div key={problem.id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
          <div className="flex-1">
            <p className="font-medium text-lg">{problem.problemName}</p>
            <p className="text-sm text-gray-500">
              Patient: {problem.patientName || ''}
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <div className="text-right mr-3">
              <Badge 
                variant="outline" 
                className={`mb-1 ${
                  problem.status === 'second' 
                    ? 'bg-purple-100 text-purple-800 border-purple-300'
                    : problem.status === 'delivered' 
                    ? 'bg-blue-100 text-blue-800 border-blue-300' 
                    : 'bg-green-100 text-green-800 border-green-300'
                }`}
              >
                {problem.status === 'second' ? 'Second' : 
                 problem.status === 'delivered' ? 'Delivered' : 'Active'}
              </Badge>
              {problem.emailSent && (
                <Badge 
                  variant="outline" 
                  className="mb-1 ml-1 bg-green-100 text-green-800 border-green-300"
                  title={`Email sent ${problem.emailSentCount > 1 ? problem.emailSentCount + ' times. ' : ''}Last sent: ${problem.lastEmailSentAt ? new Date(problem.lastEmailSentAt).toLocaleString() : new Date(problem.emailSentAt).toLocaleString()}`}
                >
                  ✉️ Email Sent{problem.emailSentCount > 1 ? ` (${problem.emailSentCount}x)` : ''}
                </Badge>
              )}
              <p className="text-sm text-gray-400">
                {new Date(problem.performedDate).toLocaleDateString()}
              </p>
            </div>
            <div className="flex flex-col space-y-1">
              <Button 
                size="sm" 
                variant="outline"
                onClick={() => handleOpenProblemView(problem.id)}
                className="text-sm px-3 py-1 h-8"
              >
                View
              </Button>
              <Button 
                size="sm" 
                variant="outline"
                onClick={() => handleEditProblem(problem.id)}
                className="text-sm px-3 py-1 h-8"
              >
                Edit
              </Button>
              <Button 
                size="sm" 
                variant="outline"
                onClick={() => handlePrintProblemById(problem.id)}
                className="text-sm px-3 py-1 h-8"
              >
                Print
              </Button>
              <Button 
                size="sm" 
                variant="outline"
                onClick={() => handleEmailProblem(problem.id)}
                className="text-sm px-3 py-1 h-8"
              >
                Email
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  </>
);
